import {userConstants} from '../../_constants';

export function addressesByCity(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ADDRESS_BY_CITY_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_ADDRESS_BY_CITY_SUCCESS:
      return {
        loading: false,
        // typeDelivery: action.data,
        ...action.data,
      };
    case userConstants.GET_ADDRESS_BY_CITY_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
